import { Injectable } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SendBackReviewPayloadService } from 'app/services/send-back-review-payload.service';

@Injectable()
export class SendBackReviewInterceptor implements HttpInterceptor {
	constructor(private readonly payloadService: SendBackReviewPayloadService) {}
	private readonly workflowReviewUrlPattern =
		/\/clients\/[0-9a-fA-F-]{36}(?:\/[^/?#]+){1,2}\/([0-9a-fA-F-]{36})\/review(?:\?|$)/i;

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.method !== 'POST') {
			return next.handle(request);
		}

		const formIdMatch = request.url.match(this.workflowReviewUrlPattern);
		if (!formIdMatch?.[1]) {
			return next.handle(request);
		}

		const formId = formIdMatch[1];
		const payload = this.payloadService.peek(formId);
		if (!payload) {
			return next.handle(request);
		}

		const formData = new FormData();
		formData.append(
			'model',
			JSON.stringify({
				comment: payload.comment?.trim() ?? '',
			})
		);

		for (let i = 0; i < payload.attachments.length; i++) {
			formData.append(`attachment-${i + 1}`, payload.attachments[i], payload.attachments[i].name);
		}

		const clonedRequest = request.clone({
			body: formData,
		});

		// Held until the submission resolves. A 401 here is followed by a silent refresh and a
		// replay of this same request, and the replay must still find the comment and
		// attachments. Anything other than a 401 is the end of this submission either way.
		return next.handle(clonedRequest).pipe(
			tap({
				next: (event) => {
					if (event instanceof HttpResponse) {
						this.payloadService.clear(formId);
					}
				},
				error: (err) => {
					if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
						this.payloadService.clear(formId);
					}
				},
			})
		);
	}
}
